<template>
  <div id="player" style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0;"></div>
  <div id="ads_overlay"></div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const player = ref(null)
const playerConfig = ref(null)
const sources = ref(null)

const defaultConfig = {
  source: '',
  mimeType: '',
  parentId: '#player',
  autoplay: true,
  poster: 'https://cdn1.jskhdkajskjsad.xyz/wp-content/uploads/2025/05/ng3.gif',
  watermark: [],
  plugins: [],
  ads: {},
  width: '100%',
  height: '100%'
}

const defaultAds = {
  preRoll: {
    enabled: true,
    src: 'https://cfstatic.xdapiym5297.com/vast/prod/kokohoki/v_10011.mp4',
    skip: true,
    timeout: 5,
    link: 'http://example.com/ad-destination',
    autoskip: 20,
    type: 'video/mp4',
    title: {
      enabled: false,
      text: '',
      style: {
        color: '#ffffff',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '5px 10px',
        position: 'top-left',
        fontSize: '14px'
      }
    }
  },
  midRoll: {
    enabled: true,
    src: 'https://cfstatic.xdapiym5297.com/vast/prod/kokohoki/v_10011.mp4',
    interval: 4,
    skip: true,
    timeout: 15,
    autoskip: 15,
    type: 'video/mp4',
    title: {
      enabled: false,
      text: '',
      style: {
        color: '#ffffff',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '5px 10px',
        position: 'top-left',
        fontSize: '14px'
      }
    }
  },
  postRoll: {
    enabled: false,
    src: 'https://cfstatic.xdapiym5297.com/vast/prod/kokohoki/v_10011.mp4',
    link: 'http://example.com/ad-destination',
    autoskip: 8,
    type: 'video/mp4',
    title: {
      enabled: false,
      text: '',
      style: {
        color: '#ffffff',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        padding: '5px 10px',
        position: 'top-left',
        fontSize: '14px'
      }
    }
  },
  text: {
    wait: 'Wait % seconds...',
    skip: 'Skip >'
  }
}

const defaultWatermarks = [
  {
    imageUrl: 'https://gudangmt.sgp1.cdn.digitaloceanspaces.com/oke1.png',
    imageLink: 'https://github.com/clappr/clappr',
    position: 'top-right'
  },
  {
    imageUrl: 'https://gudangmt.sgp1.cdn.digitaloceanspaces.com/s1.gif',
    imageLink: 'https://github.com/clappr/clappr',
    position: 'bottom-center',
    className: 'animated-watermark'
  }
]

const loadScript = (path) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    const timestamp = new Date().getTime()
    const scriptPath = path.startsWith('/src/assets/') ? path.replace('/src/assets/', '/assets/') : path
    script.src = `${scriptPath}?t=${timestamp}`
    script.onload = () => {
      console.log(`Successfully loaded script: ${scriptPath}`)
      resolve()
    }
    script.onerror = (error) => {
      console.warn(`Failed to load script: ${scriptPath}, trying alternative path...`)
      const altScript = document.createElement('script')
      const altPath = path.startsWith('/src/assets/') ? path : `/src${path}`
      altScript.src = `${altPath}?t=${timestamp}`
      altScript.onload = () => {
        console.log(`Successfully loaded script from alternative path: ${altPath}`)
        resolve()
      }
      altScript.onerror = (altError) => {
        console.error(`Failed to load script from both paths: ${scriptPath} and ${altPath}`, error)
        reject(error)
      }
      document.head.appendChild(altScript)
    }
    document.head.appendChild(script)
  })
}

const injectCustomWatermarkCSS = (customStyle) => {
  if (!customStyle) return;
  let css = '';
  if (typeof customStyle === 'string') {
    css = customStyle;
  } else if (typeof customStyle === 'object') {
    if (customStyle.container) {
      css += '.watermark-container { ';
      Object.entries(customStyle.container).forEach(([key, value]) => {
        css += `${key}: ${value}; `;
      });
      css += '}\n';
    }
    if (customStyle.image) {
      css += '.watermark-image { ';
      Object.entries(customStyle.image).forEach(([key, value]) => {
        css += `${key}: ${value}; `;
      });
      css += '}\n';
    }
  }
  if (css) {
    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = css;
    document.head.appendChild(style);
  }
}

const injectWatermarkOpacityCSS = (watermarkTimeout, watermarkVisibility) => {
  // Remove existing watermark opacity CSS if it exists
  const existingStyle = document.getElementById('watermark-opacity-custom');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  // Calculate opacity values based on timing
  // Higher timeout = more transparent when hidden (longer wait = less visible)
  // Higher visibility = more opaque when visible (longer show = more visible)
  const hiddenOpacity = Math.max(0.05, Math.min(0.3, 1 - (watermarkTimeout / 300000))); // 0.05 to 0.3 based on timeout (0-5 minutes)
  const visibleOpacity = Math.max(0.7, Math.min(1.0, 0.7 + (watermarkVisibility / 30000))); // 0.7 to 1.0 based on visibility (0-30 seconds)
  
  const css = `
    .watermark-bottom_center {
      transition: opacity 0.5s ease-in-out !important;
    }
    
    .watermark-bottom_center.watermark-hidden {
      opacity: ${hiddenOpacity} !important;
    }
    
    .watermark-bottom_center.watermark-visible {
      opacity: ${visibleOpacity} !important;
    }
    
    /* Override any existing opacity settings */
    .watermark-bottom_center[style*="opacity"] {
      transition: opacity 0.5s ease-in-out !important;
    }
  `;
  
  const style = document.createElement('style');
  style.type = 'text/css';
  style.innerHTML = css;
  style.id = 'watermark-opacity-custom';
  document.head.appendChild(style);
  
  console.log(`Watermark opacity CSS injected - Hidden: ${hiddenOpacity}, Visible: ${visibleOpacity}`);
  console.log(`Based on timeout: ${watermarkTimeout}ms, visibility: ${watermarkVisibility}ms`);
}

const overrideWatermarkTimer = () => {
  // Try multiple times to find and override the watermark plugin
  let attempts = 0;
  const maxAttempts = 10;
  
  const tryOverride = () => {
    attempts++;
    console.log(`Attempt ${attempts} to override watermark timer`);
    
    if (window.Clappr && window.Clappr.Player) {
      // Find all player instances
      const players = document.querySelectorAll('.clappr-player');
      let overrideSuccess = false;
      
      players.forEach(playerElement => {
        const player = playerElement.clapprPlayer;
        if (player && player.getPlugin && player.getPlugin('watermark')) {
          const watermarkPlugin = player.getPlugin('watermark');
          
          // Override the startBottomWatermarkTimer method
          if (watermarkPlugin && watermarkPlugin.startBottomWatermarkTimer) {
            const originalMethod = watermarkPlugin.startBottomWatermarkTimer;
            
            watermarkPlugin.startBottomWatermarkTimer = function() {
              console.log(`${this.getTimestamp()} Starting custom bottom watermark timer`);
              const bottomWatermarks = this.$el.find('.watermark-bottom_center');
              console.log(`${this.getTimestamp()} Found bottom watermarks:`, bottomWatermarks.length);
              if (bottomWatermarks.length === 0) return;

              // Ensure watermarks start with hidden class
              bottomWatermarks.removeClass('watermark-visible').addClass('watermark-hidden');
              let isVisible = false;
              console.log(`${this.getTimestamp()} Initial state: watermarks hidden`);
              
              const toggleVisibility = () => {
                console.log(`${this.getTimestamp()} Toggle called, current visibility:`, isVisible);
                if (!isVisible) {
                  // Show watermark
                  console.log(`${this.getTimestamp()} Fading in watermarks`);
                  bottomWatermarks.removeClass('watermark-hidden').addClass('watermark-visible');
                  setTimeout(() => {
                    isVisible = true;
                    console.log(`${this.getTimestamp()} Watermarks faded in`);
                    // Schedule hide after visibility duration
                    setTimeout(() => {
                      console.log(`${this.getTimestamp()} Fading out watermarks`);
                      bottomWatermarks.removeClass('watermark-visible').addClass('watermark-hidden');
                      setTimeout(() => {
                        isVisible = false;
                        console.log(`${this.getTimestamp()} Watermarks faded out`);
                        // Schedule next show after timeout
                        setTimeout(() => {
                          toggleVisibility();
                        }, this.bottomWatermarkTimeout);
                      }, 500);
                    }, this.bottomWatermarkVisibility);
                  }, 500);
                }
              };

              // Start with initial timeout before showing
              console.log(`${this.getTimestamp()} Starting initial timeout of ${this.bottomWatermarkTimeout / 1000} seconds`);
              setTimeout(() => {
                console.log(`${this.getTimestamp()} Initial timeout complete, starting watermark cycle`);
                toggleVisibility();
              }, this.bottomWatermarkTimeout);
            };
            
            overrideSuccess = true;
            console.log('Watermark timer overridden successfully');
          }
        }
      });
      
      if (overrideSuccess) {
        return true;
      }
    }
    
    if (attempts < maxAttempts) {
      setTimeout(tryOverride, 500);
    } else {
      console.warn('Failed to override watermark timer after maximum attempts');
    }
    
    return false;
  };
  
  // Start the override process
  setTimeout(tryOverride, 1000);
}

const initializeHistatsTracking = (histatsConfig) => {
  if (!histatsConfig || !histatsConfig.enabled || !histatsConfig.id) {
    console.log('Histats tracking disabled or not configured')
    return
  }

  try {
    // Create Histats script
    const histatsScript = document.createElement('script')
    histatsScript.type = 'text/javascript'
    histatsScript.innerHTML = `
      var _Hasync = _Hasync || [];
      _Hasync.push(['Histats.start', '1,${histatsConfig.id},4,0,0,0,00000000']);
      _Hasync.push(['Histats.fasi', '1']);
      _Hasync.push(['Histats.track_hits', '']);
      (function() {
        var hs = document.createElement('script'); hs.type = 'text/javascript'; hs.async = true;
        hs.src = ('//s10.histats.com/js15_as.js');
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(hs);
      })();
    `
    document.head.appendChild(histatsScript)
    console.log('Histats tracking initialized with ID:', histatsConfig.id)
  } catch (error) {
    console.error('Failed to initialize Histats tracking:', error)
  }
}

const trackHistatsEvent = (eventName, eventData = {}) => {
  if (window._Hasync && Array.isArray(window._Hasync)) {
    try {
      // Track custom event with Histats
      window._Hasync.push(['Histats.track_hits', eventName, eventData])
      console.log('Histats event tracked:', eventName, eventData)
    } catch (error) {
      console.error('Failed to track Histats event:', error)
    }
  }
}

const changeWebsiteTitle = (title) => {
  if (title && typeof title === 'string') {
    document.title = title
    console.log('Website title changed to:', title)
  }
}

const checkDomainRestriction = (allowedDomains) => {
  if (!allowedDomains) return true // If no domain restriction, allow all
  
  try {
    // Check if the page is being iframed
    if (window.self !== window.top) {
      let parentOrigin = null
      
      // Try to get parent origin with error handling for cross-origin restrictions
      try {
        parentOrigin = window.parent.location.origin
      } catch (crossOriginError) {
        console.warn('Cross-origin access blocked, checking referrer instead')
        // Fallback to document.referrer for cross-origin cases
        const referrer = document.referrer
        if (referrer) {
          try {
            parentOrigin = new URL(referrer).origin
          } catch (referrerError) {
            console.error('Failed to parse referrer:', referrerError)
            // If we can't determine the parent origin, show 404 for security
            show404Page()
            return false
          }
        } else {
          console.warn('No referrer available, showing 404 for security')
          show404Page()
          return false
        }
      }
      
      // Convert single domain to array for consistent handling
      const allowedDomainsArray = Array.isArray(allowedDomains) ? allowedDomains : [allowedDomains]
      
      // Extract origins from allowed domains
      const allowedOrigins = allowedDomainsArray.map(domain => {
        try {
          return new URL(domain).origin
        } catch (urlError) {
          console.error('Invalid domain format:', domain, urlError)
          return null
        }
      }).filter(origin => origin !== null) // Remove invalid domains
      
      console.log('Parent origin:', parentOrigin)
      console.log('Allowed origins:', allowedOrigins)
      
      // Check if parent domain matches any of the allowed domains
      const isAllowed = allowedOrigins.includes(parentOrigin)
      
      if (!isAllowed) {
        console.warn('Unauthorized iframe access detected. Showing 404.')
        show404Page()
        return false
      }
      
      console.log('Domain check passed - access allowed')
    } else {
      console.log('Direct access detected - no domain restriction needed')
    }
    return true
  } catch (error) {
    console.error('Error checking domain restriction:', error)
    // If there's an error checking the parent, show 404 for security
    show404Page()
    return false
  }
}

const show404Page = () => {
  // Replace the entire page content with a 404 message
  document.body.innerHTML = `
    <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      font-family: Arial, sans-serif;
      background-color: #f5f5f5;
      margin: 0;
      padding: 20px;
      box-sizing: border-box;
    ">
      <div style="
        text-align: center;
        background: white;
        padding: 40px;
        border-radius: 10px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        max-width: 500px;
      ">
        <h1 style="
          font-size: 72px;
          margin: 0;
          color: #e74c3c;
          font-weight: bold;
        ">404</h1>
        <h2 style="
          font-size: 24px;
          margin: 20px 0;
          color: #2c3e50;
        ">Page Not Found</h2>
        <p style="
          font-size: 16px;
          color: #7f8c8d;
          line-height: 1.6;
          margin: 0;
        ">
          The page you are looking for might have been removed, had its name changed, 
          or is temporarily unavailable.
        </p>
      </div>
    </div>
  `
  
  // Prevent any further script execution
  throw new Error('Unauthorized access - 404 page displayed')
}

const loadConfiguration = async () => {
  try {
    const response = await fetch('/ads-config.json')
    if (!response.ok) {
      console.warn('Failed to load ads-config.json, using defaults')
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const config = await response.json()

    // Check domain restriction first
    if (config.allowDomain) {
      console.log('config.allowDomain')
      console.log(config)
      const isAllowed = checkDomainRestriction(config.allowDomain)
      if (!isAllowed) {
        return // Stop execution if domain is not allowed
      }
    }

    // Change website title if specified in config
    if (config.title) {
      changeWebsiteTitle(config.title)
    }

    console.log(`config.watermarkTimeout : ${config.watermarkTimeout}`)
    console.log(`config.watermarkVisibility : ${config.watermarkVisibility}`)
    console.log(`config.enableInitialDelay : ${config.enableInitialDelay}`)
    console.log(`config.tracking : ${config.tracking}`)
    
    

    playerConfig.value = {
      ...defaultConfig,
      ads: {
        ...defaultAds,
        ...config,
        preRoll: { ...defaultAds.preRoll, ...config.preRoll },
        midRoll: { ...defaultAds.midRoll, ...config.midRoll },
        postRoll: { ...defaultAds.postRoll, ...config.postRoll },
        text: { ...defaultAds.text, ...config.text }
      },
      watermark: config.watermark || defaultWatermarks,
      poster: config.poster || defaultConfig.poster,
      watermarkTimeout: config.watermarkTimeout || 3000,
      watermarkVisibility: config.watermarkVisibility || 6000,
      enableInitialDelay: config.enableInitialDelay || false,
      tracking: config.tracking || {}
    }

    // Inject custom watermark CSS if present in config
    if (Array.isArray(playerConfig.value.watermark)) {
      console.log('playerConfig.value.watermark')
      console.log(playerConfig.value.watermark)
      playerConfig.value.watermark.forEach(wm => {
        if (wm.customStyle) {
          injectCustomWatermarkCSS(wm.customStyle)
        }
      })
    }

    // Inject watermark opacity CSS
    if (playerConfig.value.watermarkVisibility && playerConfig.value.watermarkTimeout) {
      console.log('Injecting watermark opacity CSS with values:', {
        watermarkTimeout: playerConfig.value.watermarkTimeout,
        watermarkVisibility: playerConfig.value.watermarkVisibility
      });
      injectWatermarkOpacityCSS(playerConfig.value.watermarkTimeout, playerConfig.value.watermarkVisibility)
    } else {
      console.log('Watermark opacity CSS not injected - missing values:', {
        watermarkTimeout: playerConfig.value.watermarkTimeout,
        watermarkVisibility: playerConfig.value.watermarkVisibility
      });
    }

    console.log('Configuration loaded:', playerConfig.value)
  } catch (error) {
    console.warn('Failed to load configuration, using defaults:', error)
    playerConfig.value = {
      ...defaultConfig,
      ads: defaultAds,
      watermark: defaultWatermarks
    }
  }
}

const initializePlayer = async () => {
  try {
   

    // Load Clappr core first
    await loadScript('/assets/js/core/clappr.min.js')
    console.log('Clappr core loaded')

    if (!window.Clappr) {
      throw new Error('Clappr core failed to load')
    }

    // Load ads plugin
    await loadScript('/assets/js/core/clappr.ads.js')
    console.log('Ads plugin loaded')

    // Configure plugins
    const plugins = []
    if (window.ClapprAds) {
      plugins.push(window.ClapprAds)
      console.log('Ads plugin configured')
    } else {
      console.warn('Ads plugin not found, continuing without ads')
    }

    await loadConfiguration()

    // Update player config with plugins
    playerConfig.value = {
      ...playerConfig.value,
      plugins: plugins
    }

    const params = new URLSearchParams(window.location.search)
    if (params.has('type') && params.has('src')) {
      const type = params.get('type')
      const src = params.get('src')
      handleSourceType(type, src)
    } else if (params.has('server') && params.has('param')) {
      const server = params.get('server')
      const param = params.get('param')
      handleServerType(server, param)
    }
  } catch (error) {
    console.error('Failed to initialize player:', error)
  }
}

const handleSourceType = (type, src) => {
  const decodedSrc = atob(src)
  
  switch (type) {
    case 'flv':
      playFLV(decodedSrc)
      // playFlvClappr(decodedSrc)
      break
    case 'iframe':
      playIframe(decodedSrc)
      break
    case 'hls':
      if (decodedSrc.includes('.sdp')) {
        playSDP(decodedSrc)
      } else {
        playHLS(decodedSrc)
      }
      break
    default:
      playHLS(decodedSrc)
  }
  
 
}

const handleServerType = async (server, param) => {
  try {
    switch (server) {
      case 'alpha':
        const alphaResponse = await axios.get(`https://v1.mirrorstream.xyz/hls365.php?id=${param}&mode=sources`)
        handleAlphaResponse(alphaResponse.data)
        // Initialize Histats tracking
        if (playerConfig.value.tracking && playerConfig.value.tracking.histats) {
          initializeHistatsTracking(playerConfig.value.tracking.histats)
        }
        break
      case 'charlie':
        const charlieResponse = await axios.get(`${playerConfig.value.corsbypass}https://api.mirrorstream.xyz/charlie/json/${param}.json`)
        handleCharlieResponse(charlieResponse.data)
        // Initialize Histats tracking
        if (playerConfig.value.tracking && playerConfig.value.tracking.histats) {
          initializeHistatsTracking(playerConfig.value.tracking.histats)
        }
        break
      case 'delta':
        const deltaResponse = await axios.get(`${playerConfig.value.corsbypass}https://api.mirrorstream.xyz/delta/json/${param}.json`)
        handleDeltaResponse(deltaResponse.data)
        // Initialize Histats tracking
        if (playerConfig.value.tracking && playerConfig.value.tracking.histats) {
          initializeHistatsTracking(playerConfig.value.tracking.histats)
        }
        break
      case 'beta':
        const betaResponse = await axios.get(`https://cors.livestreamapi.xyz/https://streamdata.apk150.pro/streamdata/${param}.json`)
        sources.value = betaResponse.data.sources
        let homeData = betaResponse.data.homedata
        let awayData = betaResponse.data.awaydata

        try {
          changeWebsiteTitle(`${homeData.name} vs ${awayData.name}`)

        } catch (error) {
          console.log(error)
        }
        
        // Initialize Histats tracking after title change
        if (playerConfig.value.tracking && playerConfig.value.tracking.histats) {
          initializeHistatsTracking(playerConfig.value.tracking.histats)
        }

        if (sources.value[0].type === 'iframe') {
          playIframe(sources.value[0].source)
        } else {
          playHLS(sources.value[0].source)
        }
        break
    }
  } catch (error) {
    console.error('Server type handling error:', error)
  }
}

const getMimeType = (url) => {
  if (url.includes('.m3u8')) return 'application/x-mpegURL'
  if (url.includes('.flv')) return 'video/flv'
  if (url.includes('.sdp')) return 'application/sdp'
  return 'application/x-mpegURL'
}

const playHLS = (url) => {
  if (url.includes('.flv')) {
    playFLV(url)
    return
  }

  playerConfig.value.source = url

console.log('playerConfig.value')
console.log(playerConfig.value)
  playerConfig.value.mimeType = getMimeType(url)

  if (!document.getElementById('player')) {
    console.error('Player container not found!')
    return
  }

  try {
    player.value = new Clappr.Player(playerConfig.value)
    console.log('Player initialized:', player.value)

    player.value.on(Clappr.Events.PLAYER_PLAY, () => {
      console.log('Player started playing')
    })

    player.value.on(Clappr.Events.PLAYER_ERROR, (error) => {
      console.error('Player error:', error)
    })

    player.value.on(Clappr.Events.PLAYER_READY, () => {
      console.log('Player is ready')
      player.value.play()
      // Override watermark timer after player is ready
      overrideWatermarkTimer()
    })

    player.value.on(Clappr.Events.PLAYER_FULLSCREEN, () => {
      console.log('Player entered fullscreen')
    })

    player.value.on(Clappr.Events.PLAYER_EXITFULLSCREEN, () => {
      console.log('Player exited fullscreen')
    })
  } catch (error) {
    console.error('Failed to initialize player:', error)
  }
}

async function loadFlvScripts() {
  try {
    await loadScript("/src/assets/js/flv/flv.min.js");
    console.log("FLV.js loaded");
    await loadScript("/src/assets/js/flv/clappr-flvjs-playback.min.js");
    console.log("FLV.js playback plugin loaded");
    return true;
  } catch (error) {
    console.error("Failed to load FLV scripts:", error);
    return false;
  }
}

async function playFLV(url) {
  console.log(url)
  
  const flvScriptsLoaded = await loadFlvScripts();
  if (!flvScriptsLoaded) {
    console.error("Failed to load FLV scripts, cannot play FLV.");
    return;
  }

  const playerContainer = document.getElementById("player");
  if (!playerContainer) {
    console.error("Player container not found!");
    return;
  }
  playerContainer.innerHTML = ""; // Clear existing content

  const flvPlayerOptions = {
    autoPlay: true,
    mute: false,
    source: url,
    poster: playerConfig.value.poster,
    mimeType: "video/flv",
    watermark: playerConfig.value.watermark,
    watermarkLink: playerConfig.value.watermark[0]?.imageLink,
    watermarkTimeout: playerConfig.value.watermarkTimeout,
    watermarkVisibility: playerConfig.value.watermarkVisibility,
    position: "top-right",
    language: "en",
    strings: {
      en: {
        default_error_title: "Error",
        default_error_message: "Stream Error - Please refresh or try another channel"
      }
    },
    plugins: [window.FLVJSPlayback, window.ClapprAds],
    ads: playerConfig.value.ads,
    preload: "true",
    height: "100%",
    width: "100%",
    parentId: "#player",
    fullscreen: true,
    fullscreenConfig: {
      allowFullscreen: true,
      allowFullscreenInteractive: true,
      allowFullscreenWithKeys: true
    },
    mediaControl: playerConfig.value.mediaControl
  };

  try {
    player.value = new window.Clappr.Player(flvPlayerOptions);
    
    // Start FLV watermark timer after player is ready
    player.value.on(Clappr.Events.PLAYER_READY, () => {
      console.log('FLV Player is ready, starting watermark timer');
      // startFLVWatermarkTimer();
    });

    setupPlayerEvents();
  } catch (error) {
    console.error("Failed to initialize FLV player:", error);
    // Fallback to HLS if FLV fails
    playHLS(url);
  }
}

const startFLVWatermarkTimer = () => {
  const watermarkTimeout = playerConfig.value.watermarkTimeout || 3000;
  const watermarkVisibility = playerConfig.value.watermarkVisibility || 6000;
  
  console.log(`Starting FLV watermark timer - Timeout: ${watermarkTimeout}ms, Visibility: ${watermarkVisibility}ms`);
  
  // Find bottom center watermarks
  const bottomWatermarks = document.querySelectorAll('.watermark-bottom_center');
  console.log(`Found ${bottomWatermarks.length} bottom watermarks`);
  
  if (bottomWatermarks.length === 0) {
    console.log('No bottom watermarks found, skipping timer');
    return;
  }
  
  // Ensure watermarks start hidden
  bottomWatermarks.forEach(watermark => {
    watermark.style.transition = 'opacity 0.5s ease-in-out';
    watermark.style.opacity = '0';
  });
  
  let isVisible = false;
  
  const toggleWatermark = () => {
    if (!isVisible) {
      // Show watermark
      console.log('Showing FLV watermark');
      bottomWatermarks.forEach(watermark => {
        watermark.style.opacity = '1';
      });
      isVisible = true;
      
      // Hide after visibility duration
      setTimeout(() => {
        console.log('Hiding FLV watermark');
        bottomWatermarks.forEach(watermark => {
          watermark.style.opacity = '0';
        });
        isVisible = false;
        
        // Schedule next show after timeout
        setTimeout(() => {
          toggleWatermark();
        }, watermarkTimeout);
      }, watermarkVisibility);
    }
  };
  
  // Start the cycle after initial timeout
  setTimeout(() => {
    console.log('Starting FLV watermark cycle');
    toggleWatermark();
  }, watermarkTimeout);
}

const setupPlayerEvents = () => {

  player.value.on(Clappr.Events.PLAYER_PLAY, () => {
    console.log('FLV Player started playing')
  })

  player.value.on(Clappr.Events.PLAYER_ERROR, (error) => {
    console.error('FLV Player error:', error)
  })

  player.value.on(Clappr.Events.PLAYER_READY, () => {
    console.log('FLV Player is ready')
    if (window.ClapprAds) {
      new window.ClapprAds(player.value).configure(playerConfig.value.ads)
      console.log('Ads plugin configured for FLV')
      player.value.play()
    }
    // Override watermark timer after FLV player is ready
    overrideWatermarkTimer()
  })

  player.value.on(Clappr.Events.PLAYER_FULLSCREEN, () => {
    console.log('Player entered fullscreen')
  })

  player.value.on(Clappr.Events.PLAYER_EXITFULLSCREEN, () => {
    console.log('Player exited fullscreen')
  })

  player.value.on(Clappr.Events.ADS_PLAYER_READY, () => {
    console.log('Ads player is ready')
  })

  player.value.on(Clappr.Events.ADS_PLAYER_ERROR, (error) => {
    console.error('Ads player error:', error)
  })

  player.value.on(Clappr.Events.ADS_PLAYER_STARTED, () => {
    console.log('Ads playback started')
  })

  player.value.on(Clappr.Events.ADS_PLAYER_ENDED, () => {
    console.log('Ads playback ended')
    player.value.play()
  })

  player.value.on(Clappr.Events.ADS_PLAYER_PREROLL_STARTED, () => {
    console.log('Pre-roll ad started')
  })

  player.value.on(Clappr.Events.ADS_PLAYER_PREROLL_ENDED, () => {
    console.log('Pre-roll ad ended')
  })

  player.value.on(Clappr.Events.ADS_PLAYER_PREROLL_SKIPPED, () => {
    console.log('Pre-roll ad skipped')
  })
  player.value.play()
  console.log('redi')
}

const playIframe = (url) => {
  const playerElement = document.getElementById('player')
  playerElement.innerHTML += `
    <div class="container">
      <iframe scrolling="no" class="responsive-iframe" width="560" height="315" 
        src="${url}" frameborder="0" 
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen>
      </iframe>
    </div>
  `
}

const playSDP = (url) => {
  setTimeout(() => {
    const playerElement = document.getElementById('player')
    playerElement.innerHTML = `
      <section class="player_section">
        <video id="video" class="video-js vjs-theme-custom" controls autoplay playsinline 
          style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; object-fit: cover;">
        </video>
        <input type="hidden" name="signal_url" id="signal_url" value="${url}">
        <button id="play" style="display:none;">Play</button>
        <button id="stop" style="display:none;">Stop</button>
      </section>
    `

    const plugins = [
      '/plugin/jquery.js',
      '/plugin/adapter.js',
      '/plugin/common.js',
      '/plugin/sha256.js',
      '/plugin/md5.js',
      '/plugin/env.js',
      '/plugin/report.js',
      '/plugin/play.js'
    ]

    plugins.forEach(plugin => {
      const script = document.createElement('script')
      script.src = plugin
      document.body.appendChild(script)
    })
  }, 1000)
}

function playFlvClappr(sourceUrl) {
  loadFlvScripts().then(flvScriptsLoaded => {
    if (!flvScriptsLoaded) {
      console.error("Failed to load FLV scripts, cannot play FLV.");
      return;
    }

    const playerContainer = document.getElementById("player");
    if (!playerContainer) {
      console.error("Player container not found!");
      return;
    }
    playerContainer.innerHTML = ""; // Clear existing content

    const flvPlayerOptions = {
      autoPlay: false,
      mute: true,
      source: sourceUrl,
      poster: playerConfig.value.poster,
      mimeType: "video/flv",
      watermark: playerConfig.value.watermark,
     /*  watermarkLink: playerConfig.value.watermark[0]?.imageLink,
      watermarkVisibility: playerConfig.value.watermarkVisibility,
      position: "top-right", */
      language: "en",
      strings: {
        en: {
          default_error_title: "Error",
          default_error_message: "Stream Error - Please refresh or try another channel"
        }
      },
      plugins: [window.FLVJSPlayback, window.ClapprAds],
      ads: playerConfig.value.ads,
      preload: "true",
      height: "100%",
      width: "100%",
      parentId: "#player",
      fullscreen: true,
      fullscreenConfig: {
        allowFullscreen: true,
        allowFullscreenInteractive: true,
        allowFullscreenWithKeys: true
      },
      mediaControl: playerConfig.value.mediaControl
    };

    try {
      clapprPlayerInstance.value = new Clappr.Player(flvPlayerOptions);
      // Attach event listeners as needed
    } catch (error) {
      console.error("Failed to initialize FLV player:", error);
    }
  });
}

onMounted(() => {
  initializePlayer()
})
</script>

<style>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}
</style>